import React, {createContext, useReducer} from "react";
import {PackageReducer} from "../reducer/PackageReducer";

export const PackageContext = createContext()

const PackageContextProvider = (props) => {
    const state = {
        sortPref: {column: "trackingId", direction: "ascending"},
        packageList: []
    }
    const [ viewModel, dispatch ] = useReducer(PackageReducer, state);
    return (
        <PackageContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </PackageContext.Provider>
    )
}

export default PackageContextProvider


// WEBPACK FOOTER //
// ./src/components/package/context/PackageContext.js